import type { GameId } from "./shared/catalog";

// Rendered hero artwork for each original, served from public/preview-assets/cards/.
// These replace the earlier vector concept PNGs (concepts/png/*.png), which rendered
// as flat line art. Files are keyed by game slug so the mapping is unambiguous even
// though the preview-asset numbering differs from the concept numbering.
export const cardImages: Partial<Record<GameId, string>> = {
  "stack-and-block": "/preview-assets/cards/01-stack-and-block.jpg",
  "payload-runner": "/preview-assets/cards/02-payload-runner.jpg",
  "corridor-zero": "/preview-assets/cards/03-corridor-zero.jpg",
  "rogue-app-city": "/preview-assets/cards/04-rogue-app-city.jpg",
  "latency-league": "/preview-assets/cards/05-latency-league.jpg",
  "sector-403": "/preview-assets/cards/06-sector-403.jpg",
  "one-client-rider": "/preview-assets/cards/07-one-client-rider.jpg",
  "packet-pilot": "/preview-assets/cards/08-packet-pilot.jpg",
  "phish-quest": "/preview-assets/cards/09-phish-quest.jpg",
  "ddos-bastion": "/preview-assets/cards/10-ddos-bastion.jpg",
};
